import { ReactNode } from 'react';
import { Typography } from 'antd';
import LoadingScreen from 'app/components/elements/loading_screen/loading_screen';
import 'app/hoc/page_with_loader/page_with_loader.scss';

type LoaderProps = {
    text?: string;
    textFirst?: boolean;
};

const PageWithLoader = ({
    isLoading,
    children,
    text,
    error,
    errorText,
    header,
    textFirst,
}: {
    isLoading: boolean;
    children: ReactNode;
    text?: string;
    textFirst?: boolean;
    error?: boolean | string;
    errorText?: string;
    header?: ReactNode;
}): JSX.Element => {
    const loaderProps: LoaderProps = {};
    const defaultErrorText = 'Something went wrong. Please try again.';
    if (text) loaderProps.text = text;
    if (textFirst) loaderProps.textFirst = textFirst;

    // eslint-disable-next-line react/jsx-props-no-spreading
    if (isLoading)
        return (
            <>
                {header && header}
                <LoadingScreen type={header ? 'element' : 'page'} {...loaderProps} />
            </>
        );
    if (error) return <Typography.Text>{errorText || defaultErrorText}</Typography.Text>;

    return <div className='page-with-loader'>{children}</div>;
};

export default PageWithLoader;
